import Testimonials from './Testimonials';
import FAQSection from './FAQSection';

export default function StoriesFaqBridge() {
  return (
    <div className="stories-faq-bridge">
      <div className="relative z-[2]">
        <Testimonials embedded />
        <div aria-hidden="true" className="stories-faq-bridge__divider">
          <svg
            className="stories-faq-bridge__divider-svg"
            viewBox="0 0 1440 160"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M-80 96 C 280 48, 520 112, 760 76 C 1000 40, 1240 98, 1520 64"
              stroke="url(#sfb-divider-stroke)"
              strokeWidth="1.25"
              strokeLinecap="round"
              opacity="0.55"
            />
            <path
              d="M-80 108 C 340 72, 580 124, 820 92 C 1060 60, 1280 114, 1520 82"
              stroke="url(#sfb-divider-stroke)"
              strokeWidth="0.75"
              strokeLinecap="round"
              opacity="0.35"
            />
            <defs>
              <linearGradient id="sfb-divider-stroke" x1="0" y1="0" x2="1440" y2="0" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="var(--sfb-wave-line)" stopOpacity="0" />
                <stop offset="25%" stopColor="var(--sfb-wave-line)" stopOpacity="0.9" />
                <stop offset="75%" stopColor="var(--sfb-wave-line)" stopOpacity="0.9" />
                <stop offset="100%" stopColor="var(--sfb-wave-line)" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <FAQSection embedded />
      </div>
    </div>
  );
}
